import { Injectable, inject } from '@angular/core';
import { IntegratedIReckonHotel, IntegrationIReckonHotelsAndUnitsService } from '@era/locations-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  IReckonIntegratedHotelApiActions,
  IReckonIntegratedHotelContainerActions,
  IReckonIntegratedHotelResolverActions,
} from './integrated-ireckon-hotel.actions';

@Injectable()
export class IReckonHotelEffects {
  private readonly actions$ = inject(Actions);
  private readonly hotelService = inject(IntegrationIReckonHotelsAndUnitsService);

  hotelsLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegratedHotelResolverActions.integrationRequested),
      mergeMap(({ locationUniqueId }) =>
        safeMap(
          this.hotelService.getIntegratedIReckonHotels({ hotelCode: undefined, locationUniqueId }),
          (result: IntegratedIReckonHotel[]) => IReckonIntegratedHotelApiActions.integrationsLoaded({ hotels: result }),
          (error) => IReckonIntegratedHotelApiActions.integrationsLoadedError({ error })
        )
      )
    );
  });

  hotelUpdatedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegratedHotelContainerActions.integrationUpdated),
      mergeMap(({ hotel }) =>
        hotel.id
          ? safeMap(
              this.hotelService.updateIntegratedIReckonHotel({
                integratedIReckonHotelId: hotel.id,
                integratedIReckonHotel: hotel,
              }),
              () => IReckonIntegratedHotelApiActions.integrationsUpdated({ hotel }),
              (error) => IReckonIntegratedHotelApiActions.integrationsUpdatedError({ hotel, error })
            )
          : safeMap(
              this.hotelService.addIntegratedIReckonHotel({ integratedIReckonHotelAdd: hotel }),
              () => IReckonIntegratedHotelApiActions.integrationsAdded({ hotel }),
              (error) => IReckonIntegratedHotelApiActions.integrationsAddedError({ hotel, error })
            )
      )
    );
  });
}
